import React from "react";
import { dialog } from "../../../../nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import FormFactory from "../../../../components/FormFactory";
import { Link } from "react-router-dom";
import schemaPersonalForm1 from "./schemas/schemaPersonalForm1.json";
import schemaContactPerson from "./schemas/schemaContactPerson.json";
import schemaIdForm from "./schemas/schemaIdForm.json";
import schemaEmployment from "./schemas/schemaEmployment.json";
import schemaCharacterRef from "./schemas/schemaCharacterRef.json";
import schemaElementaryForm from "./schemas/schemaElementaryForm.json";
import schemaOtherDocs from "./schemas/schemaOtherDocs.json";
import schemaHSForm from "./schemas/schemaHSForm.json";
import schemaColForm from "./schemas/schemaColForm.json";
import schemaDocForm from "./schemas/schemaDocForm.json";
import schemaPresentAddress from "./schemas/schemaPresentAddress.json";
import schemaPermanentAddress from "./schemas/schemaPermanentAddress.json";
import InputFactory from "../../../../components/InputFactory";
import NavBar from "../../../../components/navbar";
import ReprocessApplicantFormPresenter from "./ReprocessApplicantFormPresenter";
import DialogAssign from "./components/DialogAssign";
import { auditUseCase } from "../../../../usecases/audit";

class ReprocessApplicantFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
    };
    this.presenter = new ReprocessApplicantFormPresenter(
      this,
      upsertUseCase(),
      getObjectUseCase(),
      auditUseCase()
    );
  }

  getCollectionName() {
    return "reprocess_applicants";
  }

  handleClickAssign() {
    this.presenter.assignSubmit();
  }
  goBack() {
    const history = window.history;
    history.back();
  }

  assignSubmit(changeInfo, recruiter) {
    dialog.fire({
      html: (
        <DialogAssign
          handleAssign={this.handleClickAssign.bind(this)}
          change={changeInfo}
          recruiter={recruiter}
        />
      ),
      footer: false,
    });
  }

  render() {
    const { object, whereLGSSee } = this.state;
    const user = this.getCurrentUser();
    console.log("objct", object);

    const isAddressSame =
      object.permanent_barangay === object.present_barangay &&
      object.permanent_city === object.present_city &&
      object.permanent_houseNumber === object.present_houseNumber &&
      object.permanent_province === object.present_province &&
      object.permanent_street === object.present_street &&
      object.permanent_subdivision === object.present_subdivision &&
      object.permanent_zipCode === object.present_zipCode &&
      object.telephone === object.present_telephone;
    return (
      <>
        <NavBar user={user} />
        <div>
          <div className="p-4 overflow-auto">
            <div className="d-flex gap-4 justify-content-between">
              <div className="d-flex">
                <h1 className="fw-bold fs-4">
                  <div className="d-flex gap-3 align-items-center">
                    <div
                      className="rounded-5 p-1 cursor-pointer"
                      style={{ backgroundColor: `#E6E6E6` }}
                      onClick={this.goBack.bind(this)}
                    >
                      <i
                        class="bi bi-arrow-left-short"
                        style={{ width: `1rem`, height: `1rem` }}
                      ></i>
                    </div>
                    <span style={{ color: `#D18237` }}>Application Form</span>
                  </div>
                </h1>
              </div>

              <div>
                <button
                  className="btn text-white"
                  style={{ backgroundColor: "#D18237" }}
                  onClick={this.assignSubmit.bind(this)}
                  disabled={
                    user?.id === object?.recruiter?.id || object?.recruiter?.id
                  }
                >
                  <i class="bi bi-person-check me-2"></i>
                  {user?.id === object?.recruiter?.id
                    ? "Already assigned to me"
                    : object?.recruiter?.id
                    ? `Assigned to ${object.recruiter.employee.firstName} ${object.recruiter.employee.lastName}`
                    : "Assign to me"}
                </button>
              </div>
            </div>
            <div className="bg-white p-4 rounded-3 mt-3 border border-1 border-warning">
              <h6
                className="text-uppercase fw-bold mb-3"
                style={{ color: "#D18237" }}
              >
                Previous Recruiter
              </h6>
              <div
                className="d-flex flex-column gap-2"
                style={{ fontSize: "0.9rem" }}
              >
                <div className="d-flex gap-2">
                  <span className="fw-bold text-muted">Recruiter Name:</span>
                  <span className="text-dark">
                    {object?.previousRecruiter || "N/A"}
                  </span>
                </div>
                <div className="d-flex gap-2">
                  <span className="fw-bold text-muted">Remarks:</span>
                  <span className="text-dark">
                    {object?.pollRemarks || "No remarks available"}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex flex-column">
              <div className="bg-white mt-4 p-4 rounded-3 d-flex flex-column gap-0">
                <form>
                  <p className="fs-5 fw-bold p-0 m-0">Instructions:</p>
                  <p className="p-0 m-0">
                    1. Answer ALL questions completely and accurately.
                  </p>
                  <p className="p-0 m-0">
                    2. Provide all information to the best of your knowledge.
                  </p>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column justify-content-md-start mt-3 gap-2">
                      <div className="d-flex flex-column gap-2">
                        <b>Where did you see LGS?</b>
                        <InputFactory
                          type="String"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="seeLGS"
                          defaultValue={object.seeLGS}
                          disabled
                        />
                        {whereLGSSee === "Recruiter" ? (
                          <div>
                            <select className="form-control bg-light-subtle p-2">
                              <option selected disabled>
                                Select Recruiter
                              </option>
                            </select>
                          </div>
                        ) : (
                          <div className="d-flex flex-column">
                            <p className="text-muted m-0 p-0">
                              Position/s Applied for:
                            </p>

                            <InputFactory
                              type="String"
                              required
                              className="form-control bg-light-subtle p-2"
                              placeholder="Select"
                              field="positionApplied"
                              defaultValue={object.positionApplied}
                              disabled
                            />
                          </div>
                        )}
                      </div>
                      <div className="mt-2">
                        <b>Do you have any relative in:</b>
                        <div className="mt-2">
                          <label className="form-label fs-sm">LGS</label>
                          <InputFactory
                            type="String"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeLGS"
                            defaultValue={object.relativeLGS}
                            disabled
                          />
                        </div>
                        <div>
                          <label className="form-label fs-sm">Client</label>
                          <InputFactory
                            type="String"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeClient"
                            defaultValue={object.relativeClient}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-3 col-lg-6">
                      <label className="fw-bold">
                        Applicant's Image
                        <span className="text-danger fw-lighter ms-1">*</span>
                      </label>
                      {object?.image1 ? (
                        <div
                          className="border-1 border rounded-3 position-relative col-sm-6"
                          style={{ width: "300px", height: "300px" }}
                        >
                          <img
                            className="w-100 h-100 rounded-1 object-fit-contain"
                            src={`${object?.image1}`}
                            alt="Uploaded file"
                          ></img>
                          {/* <button
                            className="btn btn-sm bg-white position-absolute"
                            onClick={() => this.setState({ image: "" })}
                            style={{ top: `2%`, right: `2%` }}
                          >
                            <i className="bi bi-trash text-danger"></i>
                          </button> */}
                        </div>
                      ) : (
                        <div className="border-1 border rounded-3 position-relative col-sm-6 bg-light-subtle">
                          <a href="#uploadImage">
                            <img
                              className="w-100"
                              src="/defaultImage.png"
                              alt="Default Image"
                            ></img>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mt-5">
                    <b>Personal Information</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaPersonalForm1}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="mt-4">
                      <b>Permanent Address</b>
                    </div>
                    <FormFactory
                      schema={schemaPermanentAddress}
                      object={object}
                      disabled
                    />
                  </div>
                  {isAddressSame ? (
                    <div className="row justify-content-md-start mt-3">
                      <div className="col-md-5 d-flex gap-2">
                        <input
                          type="checkbox"
                          className="cursor-pointer"
                          checked={isAddressSame}
                          disabled
                        />
                        <p className="m-0 p-0">
                          Permanent Address same as a Present Address
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {isAddressSame ? (
                    ""
                  ) : (
                    <div className="row justify-content-md-start mt-3">
                      <div className="mt-4">
                        <b>Present Address</b>
                      </div>
                      <FormFactory
                        schema={schemaPresentAddress}
                        object={object}
                        disabled
                      />
                    </div>
                  )}

                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaIdForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>Emergency Contact Person</b>
                    <hr></hr>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaContactPerson}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>Educational Information</b>
                    <hr />
                  </div>
                  <div className="mt-4">
                    <b>High School</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaHSForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>College</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaColForm}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex">
                      <InputFactory
                        type="Boolean"
                        field="isFreshGrad"
                        label="Fresh Graduate"
                        object={object}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <b>Employment Background</b>
                    <hr />
                  </div>
                  <div>
                    <div className="row justify-content-md-start mt-3">
                      <div className="row justify-content-md-start mt-3">
                        {object.employmentBackground?.map(
                          (employment, index) => (
                            <FormFactory
                              schema={schemaEmployment}
                              object={employment}
                              disabled
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-3">
                    <b>Character References</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <div className="row justify-content-md-start mt-3">
                      {object.characterReferences?.map((reference, index) => (
                        <FormFactory
                          schema={schemaCharacterRef}
                          disabled
                          object={reference}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="mt-4">
                    <b>School Record</b>
                    <hr />
                  </div>

                  <div className="d-flex flex-row justify-content-md-start mt-3 gap-3">
                    {object?.diploma ? (
                      <div className="col-lg-3">
                        <label>Diploma</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Diploma"
                          field="diploma"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.tor ? (
                      <div className="col-lg-3">
                        <label>TOR</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="TOR"
                          field="tor"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.reportCard ? (
                      <div className="col-lg-3">
                        <label>Report Card</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Report Card"
                          field="reportCard"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.graduationCertificate ? (
                      <div className="col-lg-3">
                        <label>Graduation Certificate</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Graduation Certificate"
                          field="graduationCertificate"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-4">
                    <b>Upload Documents</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaDocForm}
                      disabled
                      object={object}
                    />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaOtherDocs}
                      disabled
                      object={object}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ReprocessApplicantFormPage);
